import { ApiClient } from "#/shared/api/client";
import { InsurancePlan } from "#ce/shared/filters/insurance-plan/models/insurance-plan";

export class InsuranceFilterApi extends ApiClient {
  constructor(options) {
    super({ ...options, model: InsurancePlan });
  }

  transform(responseData) {
    if (!responseData) {
      return null;
    }

    const { meta, data } = responseData;
    return {
      meta,
      data: super.transform(data),
    };
  }
}

/**
 * Returns the data source for the insurance plan options.
 *
 * @param {Object} [options]
 * @param {String} [options.url] - The endpoint serving the plan list. Without one, `all` rejects: the
 *   client names no route of its own.
 */
export const createInsuranceFilterApi = ({ url } = {}) => {
  if (!url) {
    return {
      all: async () => {
        throw new Error("createInsuranceFilterApi: no `url` configured for the insurance plan options");
      },
    };
  }

  const instance = new InsuranceFilterApi({ baseURL: url });

  return {
    all: async () => instance.get(""),
  };
};
